import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import clsx from "../../../util/clsx"
const useStyles = makeStyles(theme => ({
  Section: {
    padding: 0,
    margin: 0,
    background: theme.palette.background.paper,
  },
  GridContainer: {
    margin: "auto",
    padding: 0,
    marginBottom: theme.spacing(6),
    maxWidth: "100%",
    position: "relative",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gridAutoRows: "300px",
    [theme.breakpoints.up("md")]: {
      gridTemplateRows: "repeat(6, minmax(300px, 1fr))",
      gridTemplateColumns: "repeat(6, minmax(100px, 1fr))",
    },
    placeContent: "center / center",
    width: "100%",
    height: "100%",

    [theme.breakpoints.up("xl")]: {
      maxWidth: 1920,
    },

    "& div:not(:last-child)": {
      color: theme.palette.text.primary,
      border: "1px solid",
    },
    "& #galleryHeader": {
      display: "inline",
      position: "absolute",
      top: 0,
      right: 0,
      fontSize: theme.typography.fontSize + 20,
      padding: theme.spacing(1, 2),
      border: "1px solid #000",
      zIndex: 1,
      background: theme.palette.background.paper,
    },
  },
  GridItem: {
    position: "relative",
    padding: 0,
    width: "100%",

    "& img": {
      position: "absolute",
      width: "100%",
      height: "100%",
    },
  },
  GridItem_I: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "1 / 3",
      gridRow: "1 / 3",
    },
  },
  GridItem_II: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "3 / 5",
      gridRow: "1 / 2",
    },
  },
  GridItem_III: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "5 / 7",
      gridRow: "1 / 3",
    },
  },
  GridItem_IV: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "1 / 3",
      gridRow: "3 / 4",
    },
  },
  GridItem_V: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "3 / 5",
      gridRow: "2 / 4",
    },
  },
  GridItem_VI: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "5 / 7",
      gridRow: "3 / 4",
    },
  },
  GridItem_VII: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "1 / 3",
      gridRow: "4 / 7",
    },
  },
  GridItem_VIII: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "3 / 5",
      gridRow: "4 / 5",
    },
  },
  GridItem_IX: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "5 / 7",
      gridRow: "4 / 6",
    },
  },
  GridItem_X: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "1 / 3",
      gridRow: "6 / 7",
    },
  },
  GridItem_XI: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "3 / 5",
      gridRow: "5 / 7",
    },
  },
  GridItem_XII: {
    [theme.breakpoints.up("md")]: {
      gridColumn: "5 / 7",
      gridRow: "6 / 7",
    },
    background: theme.palette.background.paper,
    padding: theme.spacing(5, 3),
    display: "flex",
    flexDirection: "column",
    placeContent: "center center",
  },
  mb: {
    marginBottom: theme.spacing(2),
  },
}))

export default () => {
  const classes = useStyles()
  const [state] = React.useState({
    images: [
      {
        title: "naming-ceremony-design-2",
        imgUrl: "naming-ceremony-design.jpg",
      },
      {
        title: "naming-ceremony-design",
        imgUrl: "naming-ceremony-design-2.jpg",
      },
      { title: "50th-year-birthday", imgUrl: "50th-year-birthday.jpg" },
      { title: "wedding-decoration", imgUrl: "wedding-decoration.jpg" },
      { title: "wedding-decoration-1", imgUrl: "wedding-decoration-1.jpg" },
      { title: "wedding-decoration-2", imgUrl: "wedding-decoration-2.jpg" },
      { title: "wedding-decoration-3", imgUrl: "wedding-decoration-3.jpg" },
      {
        title: "wedding-decoration-ikeja",
        imgUrl: "wedding-decoration-Ikeja.jpg",
      },
      {
        title: "traditional-wedding-decoration",
        imgUrl: "traditional-wedding-decoration.jpg",
      },
      { title: "party-buffet", imgUrl: "party-buffet.jpg" },
      { title: "lunch-package", imgUrl: "lunch-package.jpg" },
    ],
  })
  const { images } = state
  return (
    <Box component={"section"} id="gallery" className={classes.Section}>
      <Box className={classes.GridContainer}>
        <Typography id="galleryHeader">GALLERY</Typography>
        {images.map((data, i) => (
          <Box
            key={data.title}
            className={clsx([
              classes.GridItem,
              i === 0 && classes.GridItem_I,
              i === 1 && classes.GridItem_II,
              i === 2 && classes.GridItem_III,
              i === 3 && classes.GridItem_IV,
              i === 4 && classes.GridItem_V,
              i === 5 && classes.GridItem_VI,
              i === 6 && classes.GridItem_VII,
              i === 7 && classes.GridItem_VIII,
              i === 8 && classes.GridItem_IX,
              i === 9 && classes.GridItem_X,
              i === 10 && classes.GridItem_XI,
            ])}
          >
            {data.imgUrl && <img src={data.imgUrl} alt={data.title} />}
          </Box>
        ))}

        <Box className={clsx([classes.GridItem, classes.GridItem_XII])}>
          <Typography variant="h5" className={classes.mb}>
            WE ARE WITH YOU ALL THE WAY
          </Typography>
          <Typography paragraph>
            Whether you need a quote or just someone to brainstorm with in the
            early stages of your event, we will be just a call away when you're
            finally ready to discuss your ideas.
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
